module.exports = __webpack_public_path__ + "img/icon.0b191f5c.png";